import { fetchWithAuth } from "./server/fetchWithAuth";

export async function apiFetch(url: string, options?: RequestInit) {
  const res = await fetch(url, {
    ...options,
    credentials: "include",
  });

  if (res.status === 401) {
    const currentPath = encodeURIComponent(
      window.location.pathname + window.location.search,
    );
    window.location.href = `/?signIn=true&callbackUrl=${currentPath}`;
    throw new Error("UNAUTHORIZED");
  }

  return res;
}

// export async function fetchWithAuthIgnoreUnauthorized(
//   url: string,
//   options: RequestInit = {},
// ): Promise<Response | null> {
//   try {
//     return await fetchWithAuth(url, options);
//   } catch (err) {
//     if ((err as Error).message === "UNAUTHORIZED") {
//       return new Response(JSON.stringify({ ok: false }), {
//         status: 200,
//         headers: { "Content-Type": "application/json" },
//       });
//     }
//     throw err;
//   }
// }
